var _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEars3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 85,
    viewBox: "0 0 67 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.4848,
    cy: 42.5,
    rx: 33.4848,
    ry: 42.5,
    transform: "matrix(-1 0 0 1 66.9697 0)",
    fill: "#E6AB87"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.6061,
    cy: 27.0455,
    rx: 20.6061,
    ry: 27.0455,
    transform: "matrix(-1 0 0 1 54.0908 15.4546)",
    fill: "#E97A7A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEars3);
export default __webpack_public_path__ + "static/media/ears-3.a0f035fd4b4c8a897ce3654e8d0ed3e8.svg";
export { ForwardRef as ReactComponent };